export enum MIMEType {
  IMAGE_PNG = 'image/png',
  IMAGE_JPG = 'image/jpg',
  IMAGE_JPEG = 'image/jpeg',
  APPLICATION_PDF = 'application/pdf',
}
